import { DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierInsFtpServerPanel extends Layout {
    labelSFTPServer: Label;
    panelSftpInfo: Panel;
    sourceCarrierInsControl: DataSource;
    textboxFtpPassword: Textbox;
    textboxFtpPort: Textbox;
    textboxFtpUserId: Textbox;
    textboxRemoteDirectory: Textbox;
    textboxSftpServer: Textbox;
    textboxUnloadFile: Textbox;
}
